import { useParams } from "react-router-dom";
import CheckOutContent from "./CheckOutContent";

const CheckOutPage = () => {
    const { id } = useParams();
    if (!id) return null;
    return <CheckOutContent reservationId={id} />;
};

export default CheckOutPage;
